import { useEffect, useRef } from 'react'
import { loadGoogleGsi } from '@/utils/googleGsi'

/**
 * Renders Google's official Sign-In button (Google Identity Services). On a
 * successful sign-in Google hands back a JWT `credential` (id_token) which we
 * forward to `onCredential` — the caller POSTs it to /api/auth/google/.
 */
export default function GoogleSignInButton({ clientId, onCredential, onError }) {
  const containerRef = useRef(null)
  const onCredentialRef = useRef(onCredential)
  onCredentialRef.current = onCredential

  useEffect(() => {
    if (!clientId) return
    let cancelled = false

    loadGoogleGsi()
      .then(() => {
        if (cancelled || !containerRef.current) return
        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: (response) => {
            if (response?.credential) onCredentialRef.current?.(response.credential)
          },
        })
        window.google.accounts.id.renderButton(containerRef.current, {
          type: 'standard',
          theme: 'outline',
          size: 'large',
          text: 'continue_with',
          shape: 'rectangular',
          logo_alignment: 'center',
          width: containerRef.current.offsetWidth || 320,
        })
      })
      .catch((err) => { if (!cancelled) onError?.(err) })

    return () => { cancelled = true }
  }, [clientId, onError])

  return <div ref={containerRef} className="flex justify-center" style={{ minHeight: 40 }} />
}
